export default {
  austenite: 'Austenit',
  general: 'Všeobecné vlastnosti',
};
